import { render, staticRenderFns } from "./TradesmanThumbCateList.vue?vue&type=template&id=5762a790&"
import script from "./TradesmanThumbCateList.vue?vue&type=script&lang=js&"
export * from "./TradesmanThumbCateList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports